module.exports = __webpack_public_path__ + "static/levels-build-fcfcae27a194178099fab9eea900b4b2.gif";